module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-xd-12"
  }, [_c('shopper-money-table', {
    attrs: {
      "memberAmount": _vm.memberAmount
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a1e191e6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Member/ShopperMoneyTable.vue
// module id = 2528
// module chunks = 1